import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { UsersTable } from "@/pages/users/components/users-table";

import { CreateUserDialog } from "./components/create-user-dialog";

export const UsersPage = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold tracking-tight dark:text-white">Users</h2>
          <p className="text-muted-foreground dark:text-white">
            Create, activate, deactivate, and reset passwords for admin and agent accounts.
          </p>
        </div>

        <CreateUserDialog />
      </div>

      <Card>
        <CardHeader>
          <CardTitle>User Accounts</CardTitle>
        </CardHeader>

        <CardContent>
          <UsersTable />
        </CardContent>
      </Card>
    </div>
  );
};
